import 'rsuite/Pagination/styles/index.css';
import { Pagination } from 'rsuite';
interface IPaginationComponentProps {
  totalPages: number;
  currentPage: number;
  pageChangeHandler?: (page: number) => void;
  pageSize: number;
}
const PaginationComponent = ({
  totalPages,
  currentPage,
  pageChangeHandler,
  pageSize,
}: IPaginationComponentProps) => {
  if (!totalPages || totalPages <= 1) return null;
  const totalItems = totalPages * pageSize;
  const showPrevNext = totalPages > 1;
  const showFirstLast = totalPages > 5;
  return (
    <Pagination
      prev={showPrevNext}
      next={showPrevNext}
      first={showFirstLast}
      last={showFirstLast}
      total={totalItems}
      limit={pageSize}
      activePage={currentPage}
      size="md"
      onChangePage={pageChangeHandler}
      maxButtons={3}
    />
  );
};

export default PaginationComponent;
